import { render, staticRenderFns } from "./HeaderVi.vue?vue&type=template&id=8bfc3e2e&scoped=true&"
import script from "./HeaderVi.vue?vue&type=script&lang=js&"
export * from "./HeaderVi.vue?vue&type=script&lang=js&"
import style0 from "./HeaderVi.vue?vue&type=style&index=0&id=8bfc3e2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfc3e2e",
  null
  
)

export default component.exports